import { UserType } from '../../entities/tenant/user.type';
import { AppSecurityRight } from '../modules/app.security';
import { JobSecurityRight } from '../modules/job.security.module';
import { MobileTechniciansSecurityRight } from '../modules/mobile.technicians.security.module';
import { TaskSecurityRight } from '../modules/task.security.module';
import { SecurityRole, SecurityRoleType } from '../security.role';


export class EmployeeTechnician implements SecurityRole {

    _id = 'f1e7d5f3-6abf-4ab8-a4ea-6ffd1bd12ef1';
    system = true;
    hidden = false;
    name = SecurityRoleType.EmployeeTechnician;
    type = UserType.Employee;
    description = 'Access to technician board only. Can work on a job, but can not create or delete.';
    // MAI-2200: an explicit allow-list, not a module spread or a derive wrapper. The reviewed role grants Create and Edit on
    // Items, SORs, Assets and Equipment but never Delete, which no wrapper can produce. New module rights are opt-in here.
    rights = [
        AppSecurityRight.LoginField,

        JobSecurityRight.TasksView,
        JobSecurityRight.TasksCreate,
        JobSecurityRight.TasksEdit,
        JobSecurityRight.TasksDelete,

        TaskSecurityRight.CanAccess,
        TaskSecurityRight.ManageManualTasks,
        TaskSecurityRight.DeleteMyTasks,

        MobileTechniciansSecurityRight.CanAccessJobs,
        MobileTechniciansSecurityRight.CanAccessAppointments,
        MobileTechniciansSecurityRight.CanAccessPurchaseOrders,
        MobileTechniciansSecurityRight.CanAccessTimesheets,
        MobileTechniciansSecurityRight.CanAccessWorkforceCompliance,
        MobileTechniciansSecurityRight.CanAccessStockLocations,
        MobileTechniciansSecurityRight.CanAccessStandaloneForms,
        MobileTechniciansSecurityRight.AccessAllFieldActivities,

        MobileTechniciansSecurityRight.ManagePurchaseOrders,
        MobileTechniciansSecurityRight.ManageCodesOnJob,
        MobileTechniciansSecurityRight.ManageOfficeCodesOnJob,
        MobileTechniciansSecurityRight.CanCompleteJobs,
        MobileTechniciansSecurityRight.CanCheckoutJobs,
        MobileTechniciansSecurityRight.CanPutJobsOnHold,
        MobileTechniciansSecurityRight.ManageMyActivitiesWhileJobIsOpen,
        MobileTechniciansSecurityRight.AllowSmsActivities,
        MobileTechniciansSecurityRight.AllowEditableMessages,

        MobileTechniciansSecurityRight.ManageMyTimesheets,
        MobileTechniciansSecurityRight.ManageJobManageMyTimesheets,

        MobileTechniciansSecurityRight.ManageJobViewTasks,
        MobileTechniciansSecurityRight.TasksEdit,
        MobileTechniciansSecurityRight.ManageJobViewFiles,
        MobileTechniciansSecurityRight.ManageJobViewItems,
        MobileTechniciansSecurityRight.ItemsCreate,
        MobileTechniciansSecurityRight.ItemsEdit,
        MobileTechniciansSecurityRight.SorsView,
        MobileTechniciansSecurityRight.SorsCreate,
        MobileTechniciansSecurityRight.SorsEdit,
        MobileTechniciansSecurityRight.ManageJobViewAssets,
        MobileTechniciansSecurityRight.AssetsCreate,
        MobileTechniciansSecurityRight.AssetsEdit,
        MobileTechniciansSecurityRight.ManageJobViewDefects,
        MobileTechniciansSecurityRight.ManageJobViewEquipments,
        MobileTechniciansSecurityRight.EquipmentCreate,
        MobileTechniciansSecurityRight.EquipmentEdit,
        MobileTechniciansSecurityRight.SearchAllAssets,
    ];

}
